<template>
  <div class="page-fatture-clienti-detail">
    <fatture-clienti-detail />
  </div>
</template>

<script>
import FattureClientiDetail from '@/components/ask/details/FattureClientiDetail.vue'

export default {
  name: 'ViewFattureClientiDetail',
  components: {
    FattureClientiDetail,
  },

  data() {
    return {
      pageName: 'FattureClientiDetail',
    }
  },

  created(){
    
  },

  mounted(){
    this.$eventBus.emit('page-change', {
      target: this,
      currentRoute: this.$router.currentRoute.value
    })
  },
  
}
</script>
